module.exports = __webpack_public_path__ + "media/widget/copy-b884463b.png";